import script from "./DesktopNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopNavbar.vue?vue&type=style&index=0&id=2fabf8c8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fabf8c8"]])

export default __exports__